import {
  VuexModule,
  Module,
  Mutation,
  getModule,
} from "vuex-module-decorators";
import store from "./index";
import { CampaignFilters } from "../models/campaign";

export interface DashboardFilter {
  id: string;
  filter: CampaignFilters;
}

export interface DashboardState {
  filter: DashboardFilter[];
}

@Module({
  namespaced: true,
  dynamic: true,
  store,
  name: "dashboard",
})
class Dashboard extends VuexModule implements DashboardState {
  filter: DashboardFilter[] = [];
  currentFilter: CampaignFilters | null = null;
  current_filter_id: string | null = null;

  get getFilter(): CampaignFilters | null {
    return this.currentFilter;
  }

  get getFilters(): DashboardFilter[] {
    return this.filter;
  }

  @Mutation
  setFilter(filter: DashboardFilter) {
    const f: DashboardFilter = {
      id: filter.id,
      filter: filter.filter,
    };

    const exists = this.filter.findIndex((f) => f.id === filter.id);

    if (exists !== -1) {
      this.filter[exists] = f;
      this.currentFilter = f.filter;
    } else {
      this.filter.push(f);
    }
  }

  @Mutation
  setCurrentFilterId(id: string) {
    this.current_filter_id = id;
  }

  @Mutation
  resetFilter(filter: DashboardFilter) {
    const f = this.filter.find((f) => f.id === filter.id);
  }
}

export const DashboardModule = getModule(Dashboard);
